// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Faq__container___tMg0y{padding:128px 24px}.Faq__header___21V7U{max-width:720px;margin:0 auto}.Faq__body___3ZLUb{max-width:840px;margin:40px auto 0}.Faq__title___Zj1ny{font-weight:200;font-size:48px;line-height:56px;text-align:center}.Faq__description___oigSO{color:inherit;font-weight:400;font-size:16px;line-height:24px;color:#6b6651;text-align:center}.Faq__accordion___3VwgM{margin-top:8px}.Faq__accordion___3VwgM:first-of-type{margin-top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "Faq__container___tMg0y",
	"header": "Faq__header___21V7U",
	"body": "Faq__body___3ZLUb",
	"title": "Faq__title___Zj1ny",
	"description": "Faq__description___oigSO",
	"accordion": "Faq__accordion___3VwgM"
};
module.exports = ___CSS_LOADER_EXPORT___;
